import firebase from 'firebase/app';
import 'firebase/firestore';
export const app = firebase.initializeApp({
  apiKey: 'AIzaSyAiS8okiSAQk5X3qlNDb8--Ul8Nd4fCo1A',
  projectId: 'blog-rubell-com',
});

export default firebase;
